import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const jotForm = defineConnector({
  identifier: "jotForm",
  name: "JotForm",
  tagLine: "Online form builder",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.jotform\\.com/.*",
  auth: (app) => headerAuth([{ name: "APIKEY", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "In your [JotForm account](https://www.jotform.com/myaccount/api), navigate to **Settings → API** and create a new API key.",
        },
      ],
    },
    {
      title: "Copy and paste the API key into the field below",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.jotform.com/user",
  },
});
